// ─── Proyeksi KARTU ──────────────────────────────────────────────────────────
//
// MASALAH YANG DISELESAIKAN
// Beranda `galeastore.id` mengirim 4.676.251 byte HTML (gzip ±372 KB) pada
// 2026-08-21. 95% di antaranya payload RSC, dan isinya bukan 27 kartu produk
// yang tampil melainkan 8.333 baris VARIAN yang ikut terbawa — rata-rata 309
// varian per kartu, 169 KB per kartu, dan satu blok `variations` kartu terbesar
// saja 619 KB. Audit `docs/audit-performa-2026-08.md` mencatat beranda 1,8 MB
// pada 12 Agustus; sembilan hari kemudian 4,68 MB, karena angkanya tumbuh
// mengikuti jumlah varian, bukan jumlah produk.
//
// Ongkosnya dibayar DUA KALI: origin merender payload sebesar itu tiap kali
// beranda dibuka (`cache-control: no-store` — CDN Hostinger tak pernah
// menyimpannya, `x-hcdn-cache-status: DYNAMIC`), lalu reseller mengunduhnya di
// 4G. Probe 90 sampel pada 21 Agustus menangkap 3,3% request macet total
// ("timed out after 25 s with 0 bytes received") pada KEDUA domain yang berbagi
// satu proses Node — dan tiap request yang macet muncul di layar pembeli
// sebagai "Anda sedang offline".
//
// KENAPA AMAN MEMANGKASNYA
// Kartu tidak pernah membaca `variations` sendiri. `HomeProductCard` hanya
// menyentuh slug/nama/brand/status/deadline/estimatedReady/images, dan satu-
// satunya pembaca varian di jalur kartu adalah `pricing.ts`, yang selalu lewat
// VARIAN PERWAKILAN — `representativeVariant()` dan `resolveSelectionPrice()`
// sama-sama mengambil "varian PERTAMA yang `price_normal`-nya terdefinisi".
// Menyisakan tepat varian itu membuat `getProductPrice`, `getProductNormalPrice`,
// dan `getDiscountInfo` memulangkan angka yang IDENTIK — bukan sekadar mirip.
//
// Tidak ada varian ber-harga → array KOSONG, supaya `.find()` tetap memulangkan
// `undefined` dan fallback ke `products.price_normal` berjalan persis seperti
// sebelumnya.
//
// ⛔ BATAS PEMAKAIAN — proyeksi ini UNTUK MENAMPILKAN KARTU SAJA. Ia sengaja
// TIDAK memenuhi kebutuhan:
//   · halaman detail produk (`getCachedProductBySlug`) — picker varian butuh
//     seluruh kombinasi, dan produk mega-varian sudah punya jalurnya sendiri
//     (`src/lib/lazyVariants.ts`, ambang 200);
//   · `/cari` — `matchedVariantLabel()` mencocokkan `name`/`sku` TIAP varian,
//     jadi `SearchClient` sengaja DIBIARKAN memakai kartu penuh;
//   · keranjang & checkout — jalur uang. Aman hari ini karena tak satu pun
//     komponen kartu menulis baris keranjang (keduanya hanya membaca
//     `totalQty` untuk badge), dan menambah kemampuan itu di masa depan WAJIB
//     memakai produk hasil jalur detail, bukan kartu.
//
// Ini BUKAN "potong daftar varian" ala kelas bug mig 212: tak ada kombinasi
// yang menjadi mustahil dipesan, karena pemesanan tidak pernah terjadi dari
// kartu.

import type { Product } from "@/lib/products";

/**
 * Buang dari sebuah produk segala hal yang tak pernah dibaca sebuah KARTU.
 *
 * Menyisakan varian perwakilan (varian pertama yang ber-`price_normal`) supaya
 * seluruh fungsi di `pricing.ts` memilih varian yang sama seperti saat daftar
 * penuh dikirim, dan mengosongkan `variantGroups` yang hanya dipakai picker
 * halaman detail serta form admin.
 */
export function toCardProduct(product: Product): Product {
  const representative = product.variations.find(
    (variant) => variant.price_normal !== undefined
  );

  return {
    ...product,
    variations: representative ? [representative] : [],
    variantGroups: [],
  };
}

/** Versi daftar — dipakai pemanggil hidrasi kartu (server maupun klien). */
export function toCardProducts(products: readonly Product[]): Product[] {
  return products.map(toCardProduct);
}
